import React, { FC } from 'react';
import { Icon, Icons, IconDefinition } from '../Icon';
import { MainIcon, TitleText } from './Title.styled';

type TitleProps = {
  title: string;
  icon: IconDefinition | Icons;
  color?: string;
};

export const Title: FC<TitleProps> = ({ title, icon, color }) => (
  <TitleText>
    <MainIcon color={color}>
      <Icon icon={icon} />
    </MainIcon>
    {title}
  </TitleText>
);
